import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcInput } from '@one/react';

export type PocInputProps = ComponentPropsWithoutRef<typeof OwcInput>;

export const PocInput = forwardRef<ElementRef<typeof OwcInput>, PocInputProps>((props, ref) => (
    <OwcInput ref={ref} {...props} />
));

PocInput.displayName = 'PocInput';
